class Anchor {
  constructor() {
    this.header = document.querySelector('.iz-header');
    this.hashlinks = Array.from(document.querySelectorAll('a[href*="#"]'));
    this.addScrollTo();
    this.handleInitialHash();
  }

  addScrollTo() {
    if (this.hashlinks.length === 0) return;

    this.hashlinks.forEach(link => {

      const hash = link.getAttribute('href').split('#')[1];

      if (hash) {
        const targetElement = document.querySelector("#" + hash);
        if (targetElement) {

          link.addEventListener('click', (event) => {
            if (link.classList.contains('lc-quick-access-archiv__link')) {
              return;
            }

            event.preventDefault();

            setTimeout(() => {
              const popupBackground = document.querySelector(".iz-notes__background");
              if (popupBackground) {
                const event = new Event("click", { bubbles: true, cancelable: true });
                popupBackground.dispatchEvent(event);
              }
            }, 250);

            const targetHash = `#${hash}`;
            this.openAccordionAndScroll(targetHash);
          });
        }
      };
    });
  }

  handleInitialHash() {
    setTimeout(() => {
      if (window.location.hash) {
        const hash = decodeURIComponent(window.location.hash);
        this.openAccordionAndScroll(hash);
      }
    }, 50);
  }

  openAccordionAndScroll(hash) {
    const targetElement = document.querySelector(hash);
    if (!targetElement) return;

    const accordion = targetElement.closest('.lc-accordion');
    if (accordion && !accordion.classList.contains('is-open')) {
      this.openAccordion(accordion, () => {
        this.scrollToElementWithOffset(targetElement);
      });
    } else {
      this.scrollToElementWithOffset(targetElement);
    }
  }

  openAccordion(accordion, callback) {
    if (accordion.classList.contains('is-open')) return;

    accordion.classList.add('is-open');

    const innerHead = accordion.querySelector('.lc-accordion__inner-head.lc-component');
    if (innerHead) {
      innerHead.classList.add('active');
    }

    const content = accordion.querySelector('.lc-accordion__content');
    if (content) {
      content.classList.add('active');
      content.style.height = "auto";
      content.style.maxHeight = "";
    }

    setTimeout(() => {
      if (callback) callback();
    }, 300);
  }

  scrollToElementWithOffset(targetElement) {
    setTimeout(() => {
      const offset = this.header ? this.header.clientHeight + 20 : -30;
      const distanceToScroll = targetElement.getBoundingClientRect().top + window.scrollY - offset;

      if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: distanceToScroll, behavior: "smooth" });
      } else {
        window.requestAnimationFrame(() => {
          window.scrollTo(0, distanceToScroll);
        });
      }
    }, 300);
  }
}

export default Anchor;


// Works But not in Safari

// class Anchor {
//   constructor() {
//     this.header = document.querySelector('.iz-header');
//     this.hashlinks = Array.prototype.slice.call(document.querySelectorAll('a[href*="#"'))
//     this.addScrollTo();
//     this.handleInitialHash();
//     if(this.hashlinks.length != 0){
//         this.addScrollTo();
//       }
//   }

//   addScrollTo() {
//     if (this.hashlinks.length === 0) return;

//     this.hashlinks.forEach(link => {
//       link.addEventListener('click', (event) => {


//         if (link.classList.contains('lc-quick-access-archiv__link')) {
//           return;
//         }
//         event.preventDefault();
//         if (link.href.includes("#")) {

//           setTimeout(() => {
//             const popupBackground = document.querySelector(".iz-notes__background");
//             if (popupBackground) {
//               popupBackground.click();
//             }
//           }, 250);
//         }

//         const hash = link.getAttribute('href').split('#')[1];

//         if (hash) {
//           const targetHash = `#${hash}`;
//           this.openAccordionAndScroll(targetHash);
//         }
//       });
//     });
//   }

//   handleInitialHash() {
//     if (window.location.hash) {
//       const hash = decodeURIComponent(window.location.hash);
//       this.openAccordionAndScroll(hash);
//     }
//   }

//   openAccordionAndScroll(hash) {
//     const targetElement = document.querySelector(hash);
//     if (!targetElement) return;

//     const accordion = targetElement.closest('.lc-accordion');
//     if (accordion && !accordion.classList.contains('is-open')) {
//       this.openAccordion(accordion, () => {
//         this.scrollToElementWithOffset(targetElement);
//       });
//     } else {
//       this.scrollToElementWithOffset(targetElement);
//     }
//   }

//   openAccordion(accordion, callback) {
//     if (accordion.classList.contains('is-open')) return;

//     accordion.classList.add('is-open');

//     const innerHead = accordion.querySelector('.lc-accordion__inner-head.lc-component');
//     if (innerHead) {
//       innerHead.classList.add('active');
//     }

//     const content = accordion.querySelector('.lc-accordion__content');
//     if (content) {
//       content.classList.add('active');
//       content.style.height = "auto";
//       content.style.maxHeight = "";
//     }
//     setTimeout(() => {
//       if (callback) callback();
//     }, 300);
//   }

//   scrollToElementWithOffset(targetElement) {
//     setTimeout(() => {
//       const offset = this.header ? this.header.clientHeight + 20 : -30;
//       const distanceToScroll = targetElement.getBoundingClientRect().top + window.scrollY - offset;

//       window.scrollTo({
//         top: distanceToScroll,
//         behavior: 'smooth',
//       });
//     }, 300);
//   }
// }

// export default Anchor;








// class Anchor {
//   constructor() {
//     this.header = document.querySelector('.iz-header');
//     this.hashlinks = Array.from(document.querySelectorAll('.lc-accordion__inner a[href*="#"]'));
//     this.addScrollTo();
//     this.handleInitialHash();
//   }

//   addScrollTo() {
//     if (this.hashlinks.length === 0) return;
//     console.log(2)
//     this.hashlinks.forEach(link => {
//       link.addEventListener('click', (event) => {
//         event.preventDefault();

//         // If the link has 'lc-quick-access-archiv__link' class, don't process it further
//         if (link.classList.contains('lc-quick-access-archiv__link')) {
//           return;
//         }

//         // Prevent the popup logic if the link href contains a hash (#)
//         if (link.href.includes("#")) {
//           // Skip popup background logic when there's a hash
//           const hash = link.getAttribute('href').split('#')[1];
//           if (hash) {
//             const targetHash = `#${hash}`;
//             this.openAccordionAndScroll(targetHash);
//           }
//         } else {
//           // The popup behavior for non-hash links
//           setTimeout(() => {
//             const popupBackground = document.querySelector(".iz-notes__background");
//             popupBackground.click();
//           }, 250);
//         }
//       });
//     });
//   }

//   handleInitialHash() {
//     if (window.location.hash) {
//       const hash = decodeURIComponent(window.location.hash);
//       this.openAccordionAndScroll(hash);
//     }
//   }

//   openAccordionAndScroll(hash) {
//     const targetElement = document.querySelector(hash);
//     if (!targetElement) return;

//     const accordion = targetElement.closest('.lc-accordion');
//     if (accordion && !accordion.classList.contains('is-open')) {
//       this.openAccordion(accordion, () => {
//         this.scrollToElementWithOffset(targetElement);
//       });
//     } else {
//       this.scrollToElementWithOffset(targetElement);
//     }
//   }

//   openAccordion(accordion, callback) {
//     if (accordion.classList.contains('is-open')) return;

//     // Add "is-open" class to the accordion
//     accordion.classList.add('is-open');

//     // Find `.lc-accordion__inner-head.lc-component` and add "active"
//     const innerHead = accordion.querySelector('.lc-accordion__inner-head.lc-component');
//     if (innerHead) {
//       innerHead.classList.add('active');
//     }

//     // Find `.lc-accordion__content`, remove maxHeight, and set height to auto
//     const content = accordion.querySelector('.lc-accordion__content');
//     if (content) {
//       content.classList.add('active');
//       content.style.height = "auto";  // Set height to auto
//       content.style.maxHeight = "";  // Remove any previously set maxHeight
//     }

//     // Wait a bit for the accordion animation to complete, then scroll
//     setTimeout(() => {
//       if (callback) callback();
//     }, 300);
//   }

//   scrollToElementWithOffset(targetElement) {
//     setTimeout(() => {
//       const offset = this.header ? this.header.clientHeight + 20 : -30;
//       const distanceToScroll = targetElement.getBoundingClientRect().top + window.scrollY - offset;

//       window.scrollTo({
//         top: distanceToScroll,
//         behavior: 'smooth',
//       });
//     }, 100);
//   }
// }




//  class Anchor {
//    constructor() {
//      this.header = document.querySelector('.iz-header');
//      this.hashlinks = Array.from(document.querySelectorAll('.lc-accordion__inner a[href*="#"]'));
//      this.addScrollTo();
//      this.handleInitialHash();
//      if(this.hashlinks.length != 0){
//       this.addScrollTo();
//     }
//    }

//    addScrollTo() {
//      if (this.hashlinks.length === 0) return;

//      this.hashlinks.forEach(link => {
//        link.addEventListener('click', (event) => {
//          event.preventDefault();

//          if (link.classList.contains('lc-quick-access-archiv__link')) {
//           return;
//         }


//          if (link.href.includes("#")) {
//            setTimeout(() => {
//              const popupBackground = document.querySelector(".iz-notes__background");
//              popupBackground.click()
//            }, 250)
//          }

//          const hash = link.getAttribute('href').split('#')[1];

//          if (hash) {
//            const targetHash = `#${hash}`;
//            this.scrollToElementWithOffset(targetHash);
//          }
//        });
//      });
//    }

//    handleInitialHash() {
//      if (window.location.hash) {
//        const hash = decodeURIComponent(window.location.hash);
//        this.scrollToElementWithOffset(hash);
//      }
//    }

//    scrollToElementWithOffset(hash) {
//      const targetElement = document.querySelector(hash);

//      if (!targetElement) {
//        return;
//      }

//      const accordion = targetElement.closest('.lc-accordion');
//      if (accordion && !accordion.classList.contains('is-open')) {
//        const toggleButton = accordion.querySelector('.lc-accordion__head');
//        if (toggleButton) {
//          toggleButton.click();
//        }
//      }


//      setTimeout(() => {
//        const offset = this.header ? this.header.clientHeight + 20 : -30;
//        const distanceToScroll = targetElement.getBoundingClientRect().top + window.scrollY - offset;


//        window.scrollTo({
//          top: distanceToScroll,
//          behavior: 'smooth',
//        });
//      }, 300);
//    }
//  }


// // export default Anchor;
// class Anchor {
//   constructor() {
//     this.header = document.querySelector('.iz-header');
//     this.hashlinks = Array.prototype.slice.call(document.querySelectorAll('a[href*="#"'));

//     this.scrollToHash();

//     if(this.hashlinks.length != 0){
//       this.addScrollTo();
//     }
//   }

//   addScrollTo() {
//     this.hashlinks.forEach(link => {
//       link.addEventListener('click', (e) => {
//         if (link.classList.contains('lc-quick-access-archiv__link')) {
//           return;
//         }
//         e.preventDefault();
//         const targetHash = link.getAttribute('href');
//         history.pushState(null, null, targetHash);
//         this.scrollToHash();
//       });
//     });
//   }

//   scrollToHash() {
//     const hash = window.location.hash;
//     if (hash) {

//       this.scrollToElementWithOffset(hash);
//     }
//   }

//   scrollToElementWithOffset(hash) {
//     setTimeout(() => {
//       if(document.querySelector(hash)) {
//         const distanceToNextDiv = document.querySelector(hash).offsetTop - window.scrollY - this.header.clientHeight;
//         window.scrollBy({
//           top: distanceToNextDiv,
//           behavior: "smooth"
//         });
//       }
//     }, 100);
//   }

// }


